import LanguageProblem from '@/models/read/LanguageProblem';

class LanguageProblemCategory {
    constructor({
        title,
        problems,
    }) {
        this._title = title;
        this._problems = problems.filter(problem => problem.selected).map(problem => new LanguageProblem(problem));
    }

    get title() {
        return this._title;
    }
    get problems() {
        return this._problems;
    }
}

export default LanguageProblemCategory;
